import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DefaultSharedModule } from '@homeleite/default-shared';
import { LayoutBaseComponent } from './layout-base.component';


@NgModule({
  declarations: [LayoutBaseComponent],
  imports: [
    CommonModule,
    DefaultSharedModule
  ],
  exports: [LayoutBaseComponent]
})
export class LayoutBaseModule { }
